/**
 * @deprecated
 * use PRIZM_DATE_TIME_SEPARATOR_NGX
 * */
export const PRIZM_DATE_TIME_SEPARATOR = ` `;

export const PRIZM_DATE_TIME_SEPARATOR_NGX = ` `;
